module.exports = __webpack_public_path__ + "img/slide-create-card.59a0a814.png";